export enum ROOM_STATUS {
  UNPUBLISHED = 'UNPUBLISHED',
  PUBLISHED = 'PUBLISHED',
  DELETED = 'DELETED',
}

export type RoomStatus = (typeof ROOM_STATUS)[keyof typeof ROOM_STATUS];
